module.exports = __webpack_public_path__ + "static/mobileheadingimage-c92458a5375cded560bbe2e37784ed77.png";